import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Divider,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import HttpService from "../../hooks/Https-services";
import PageRoutes, {
  APIRoutes,
  INSIDER_PLAN_ID,
  UserRoles,
  WHIZZARD_TYPE,
} from "../../utils/constants";
import ShortContentCard from "./ShortContentCard";
import Grid2 from "@mui/material/Unstable_Grid2";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import useCommonDetails from "../../Common/Hooks/useCommonDetails";
import { getCurrentAuth } from "../../hooks/http-server";
import { toast } from "react-toastify";
import useConfig from "../../hooks/useConfig";
import LatestVideo from "./LatestVideo";
import ChannelHighLights from "./ChannelHighLights";
import React from "react";
import { GoalAndCondenced } from "./ShortContentGoalandCondenced";
import { ScrollToTop } from "../../Common/Component/ScrollToTop";
const ShortContent = () => {
  const [clips, setClips] = useState<any>(null);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [videoList, setVideoList] = useState<any>([]);
  const navigate = useNavigate();
  const [subscriptionDetails, setSubscriptionDetails] = useState<any>({});
  const [slider, setSlider] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState<any>(null);
  const configData = useConfig();
  const [planDetails, setPlanDetails] = useState<any>(null);
  const userDetails = useCommonDetails();
  const auth = getCurrentAuth();
  const [channels, setChannels] = useState<any>([]);
  const GetUserSubscriptionData = useCallback(async () => {
    if (!auth.AccessToken) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const res = await HttpService.get(APIRoutes.GetSubscriptionDetials);

      if (res?.data?.data) {
        setSubscriptionDetails(res?.data?.data?.subscription);
        setPlanDetails(res?.data?.data);
        setIsLoading(false);
        return res?.data?.data;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (auth.AccessToken) {
      GetUserSubscriptionData();
    }
  }, [GetUserSubscriptionData, auth.AccessToken]);

  const hasPermition = () => {
    if (
      (planDetails?.plan_type_id == INSIDER_PLAN_ID &&
        !subscriptionDetails?.pause_collection) ||
      [
        UserRoles.HTP_ADMIN,
        UserRoles.LEAGUE_ADMIN,
        UserRoles.FREE_WATCH_D,
      ].includes(userDetails?.UserRoleID)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const FetchTenantConfig = useCallback(async () => {
    try {
      const result = await HttpService.get(APIRoutes.getTenantConfig);
      const data = result.data.data;
      console.log(data);
      setChannels(
        result.data?.data?.TenantDetails?.wizzard_settings?.channels || []
      );
    } catch (error) {}
  }, []);

  useEffect(() => {
    FetchTenantConfig();
  }, [FetchTenantConfig]);
  if (isLoading) {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }
  console.log(selectedChannel);
  return (
    <Box
      sx={{
        p: 4,
        px: { xs: 4, sm: 4, md: 8 },
      }}
    >
      <ScrollToTop />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          px: 1,
          py: 2,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 600 }}></Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            maxWidth: "300px",
            width: "100%",
          }}
        >
          <Autocomplete
            size="small"
            fullWidth
            value={selectedChannel}
            onChange={(e, value: any) => setSelectedChannel(value)}
            getOptionLabel={(option: any) => option.channel_name}
            options={channels?.map((channel: any) => channel)}
            renderInput={(params) => (
              <TextField {...params} label="Search by channel name" />
            )}
          />
        </Box>
      </Box>
      <Box
        sx={{
          opacity: !hasPermition() ? 0.3 : 1,
          backgroundColor: !hasPermition() ? configData.primary : "",
          filter: !hasPermition() ? "blur(1px)" : "",
        }}
      >
        <LatestVideo
          hasPermition={hasPermition}
          channels={channels}
          selectedChannel={selectedChannel?.channel_id || ""}
          setSelectedChannel={setSelectedChannel}
        />
        <Divider sx={{ mt: 3 }} />

        <Box>
          {hasPermition()
            ? channels
                ?.filter((channel: any) => {
                  if (!selectedChannel) return true;
                  return channel.channel_id === selectedChannel?.channel_id;
                })
                ?.map((channel: any) => (
                  <GoalAndCondenced
                    key={channel.id}
                    id={channel.id}
                    channel={channel}
                    hasPermition={hasPermition()}
                    type={3}
                  />
                ))
            : channels?.length > 0 && (
                <GoalAndCondenced
                  key={channels[0]?.id}
                  id={channels[0]?.id}
                  channel={channels[0]}
                  hasPermition={hasPermition()}
                  type={3}
                />
              )}
          <Box sx={{ py: 2 }}>
            {hasPermition()
              ? channels
                  ?.filter((channel: any) => {
                    if (!selectedChannel) return true;
                    return channel.channel_id === selectedChannel?.channel_id;
                  })
                  ?.map((channel: any) => (
                    <GoalAndCondenced
                      key={channel.id}
                      id={channel.id}
                      channel={channel}
                      hasPermition={hasPermition()}
                      type={2}
                    />
                  ))
              : channels?.length > 0 && (
                  <GoalAndCondenced
                    key={channels[0]?.id}
                    id={channels[0]?.id}
                    channel={channels[0]}
                    hasPermition={hasPermition()}
                    type={2}
                  />
                )}
          </Box>
        </Box>
      </Box>

      {!hasPermition() && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            right: 0,
            width: 1,
            bottom: "50%",
            left: 0,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: configData.primary,
              fontSize: 18,
              fontWeight: 600,
            }}
            variant="body1"
          >
            {!auth.AccessToken ? (
              <Button
                variant="contained"
                onClick={() => navigate(PageRoutes.Login)}
              >
                Log in to see the highlights
              </Button>
            ) : (
              "This feature is only available to insiders"
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ShortContent;
